import { storeWrapper } from '../storeWrapper'
import { debounce } from '@repo/utils/debounce'
import { ospreyAPI } from '@repo/api/ospreyAPI'
import { extractClientMatterNumbers } from '@repo/utils/clientMatterNumbers'

const initialState = {
  invoiceControlBalances: []
}

export const useInvoiceControlStore = storeWrapper('useInvoiceControlStore', (set) => ({
  ...initialState,
  fetchInvoiceControlBalances: async ({ clientMatterNo, matterWorkspaceVisible }) => {
    return new Promise((resolve) => {
      debounce({
        id: `fetchInvoiceControl_${clientMatterNo}`,
        delay: 500,
        callback: async () => {
          const { clientNo, matterNo } = extractClientMatterNumbers({ clientMatterNo })
          const service = 'matters'
          const endpoint = matterWorkspaceVisible ? 'Matter/GetOpenInvoices' : 'Client/GetOpenInvoices'
          const data = matterWorkspaceVisible ? { clientNo: clientNo, matterNo: matterNo } : { clientNo: clientNo }

          let fetchedInvoiceControl

          try {
            fetchedInvoiceControl =
              (await ospreyAPI({
                service: service,
                endpoint: endpoint,
                data: data
              })) || {}
          } catch (err) {
            console.log('Error:', err)
            return
          }

          set({ invoiceControlBalances: fetchedInvoiceControl })
          resolve(fetchedInvoiceControl)
        }
      })
    })
  },
  reset: () => set(initialState)
}))
